export function calcolaIndiceGlobaleOrdine({
  listaId,
  idSpedizione,
  page,
  perPage,
}) {
  if (!Array.isArray(listaId) || idSpedizione === undefined) {
    return null;
  }

  const indexNellaPagina = listaId.findIndex(
    (id) => String(id) === String(idSpedizione),
  );
  const pagina = Number(page);
  const righePerPagina = Number(perPage);
  if (
    indexNellaPagina < 0 ||
    !Number.isInteger(pagina) ||
    pagina < 1 ||
    !Number.isInteger(righePerPagina) ||
    righePerPagina < 1
  ) {
    return null;
  }

  const listaCompletaLegacy = listaId.length > righePerPagina;
  return listaCompletaLegacy
    ? indexNellaPagina
    : (pagina - 1) * righePerPagina + indexNellaPagina;
}

export function estraiIdOrdiniAdiacenti(listaId, idSpedizione) {
  if (!Array.isArray(listaId)) {
    return { idPrecedente: null, idSuccessivo: null };
  }

  const indexCorrente = listaId.findIndex(
    (id) => String(id) === String(idSpedizione),
  );
  if (indexCorrente < 0) {
    return { idPrecedente: null, idSuccessivo: null };
  }

  return {
    idPrecedente: listaId[indexCorrente - 1] ?? null,
    idSuccessivo: listaId[indexCorrente + 1] ?? null,
  };
}

export function creaParametriNavigazioneOrdini({
  ricerca,
  columnSort,
  directionSort,
  navigationIndex,
  vista,
}) {
  const ricercaConVista =
    vista === "note" ? { ...(ricerca || {}), includeNote: "1" } : ricerca;
  return new URLSearchParams({
    ...(ricercaConVista || {}),
    columnSort: columnSort || "",
    directionSort: directionSort || "",
    navigationIndex: String(navigationIndex),
  });
}
